import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'pdf-viewer-footer',
  templateUrl: './pdf-viewer-footer.component.html',
  styleUrls: ['./pdf-viewer-footer.component.scss']
})
export class PdfViewerFooterComponent implements OnInit {

  constructor(private userService: UserService) { }

  ngOnInit() {
  }

  get logoImage() {
    return this.userService.logoImage;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/pdf-viewer/pdf-viewer-footer/pdf-viewer-footer.component.ts